import * as React from 'react';
import {classNames, variationName} from '@shopify/react-utilities/styles';
import {keycodes} from 'utilities';
import {NOOP} from 'components/UIKit/utilities';
import {NavItemData} from '../../types';
import {NavItem} from '../NavItem';
import {MegaNav} from '../MegaNav';
import * as styles from './MegaNavPopover.scss';

interface MegaNavPopoverProps {
  open: boolean;
  label: string;
  openNavs: string[];
  onOpen: () => any;
  onClose: () => any;
  onActiveNavs: (itemPath) => any;
  shopNavItems: NavItemData[];
  infoNavItems: NavItemData[];
}

const HOVER_GRACE_PERIOD = 500;

export class MegaNavPopover extends React.PureComponent<MegaNavPopoverProps> {
  container: any;
  newHoverTimer: any = null;

  constructor(props) {
    super(props);
  }

  clearHoverTimer = () => {
    this.newHoverTimer = null;
  };

  handleButtonClick = () => {
    const {onOpen = NOOP} = this.props;
    onOpen();
  };

  handleButtonMouseMove = (event) => {
    event.stopPropagation();
    if (this.newHoverTimer) {
      clearTimeout(this.newHoverTimer);
      this.clearHoverTimer();
    }
    if (this.props.open) {
      return;
    }
    const {onOpen = NOOP} = this.props;
    onOpen();
  };

  handleContainerMouseMove = (event) => {
    if (this.newHoverTimer) {
      clearTimeout(this.newHoverTimer);
      this.clearHoverTimer();
    }
    event.stopPropagation();
  };

  handleContainerKeydown = (event) => {
    if (event.which === keycodes.SPACE) {
      event.preventDefault();
    } else if (event.which === keycodes.ESCAPE) {
      const {onClose = NOOP} = this.props;
      event.preventDefault();
      event.stopPropagation();
      onClose();
    }
  };

  handleFocusin = (event) => {
    const closed = !this.props.open;
    if (closed) {
      return;
    }

    if (!this.container.contains(event.target)) {
      const {onClose = NOOP} = this.props;
      onClose();
    }
  };

  doClose = () => {
    const closed = !this.props.open;
    if (closed) {
      return;
    }

    const {onClose = NOOP} = this.props;
    onClose();

    this.clearHoverTimer();
  };

  handleCurtainMouseMove = (event) => {
    event.stopPropagation();
    event.preventDefault();

    if (this.newHoverTimer !== null) {
      return;
    }
    this.newHoverTimer = setTimeout(this.doClose, HOVER_GRACE_PERIOD);
  };

  setContainerRef = (element) => {
    this.container = element;
  };

  componentDidMount() {
    window.addEventListener('focusin', this.handleFocusin);
  }

  componentWillUnmount() {
    window.removeEventListener('focusin', this.handleFocusin);
  }

  render() {
    const {
      label,
      open = false,
      openNavs,
      onActiveNavs = NOOP,
      shopNavItems,
      infoNavItems,
    } = this.props;
    const activeMenuDepth = openNavs.length;

    return (
      <li
        className={styles.container}
        onKeyDown={this.handleContainerKeydown}
        onMouseMove={this.handleContainerMouseMove}
        ref={this.setContainerRef}
      >
        <NavItem
          label={label}
          display="dropdown"
          element="div"
          className={styles.trigger}
          onClick={this.handleButtonClick}
          onMouseMove={this.handleButtonMouseMove}
          open={open}
        />

        {open && <div className={styles.curtain} onMouseMove={this.handleCurtainMouseMove} />}

        <div
          className={classNames(
            styles.popover,
            styles[variationName('width', activeMenuDepth)],
            open && styles.open,
          )}
        >
          <MegaNav
            openNavs={openNavs}
            onActiveNavs={onActiveNavs}
            shopNavItems={shopNavItems}
            infoNavItems={infoNavItems}
          />
        </div>
      </li>
    );
  }
}
